/* Colours of the model on the product page (snippets/flux-colors; styles in assets/product.css, «Colours of the model»).
   Motion of the «Кадр» prototype: the viewfinder corners mark the colour in focus and fly to the hovered tile (placed
   from the tile's own box, so a wrapped row works too), «Колір · …» follows the pointer, and on hover screens the
   first gallery photo turns into that colour with its name on the «1 / N» tag. Leaving the row puts everything back;
   a click opens the colour as before. */
(() => {
  const root = document.querySelector('[data-flux-colors]');
  if (!root) return;
  const list = root.querySelector('.flux-colors__list');
  const mark = root.querySelector('.flux-colors__mark');
  const value = root.querySelector('[data-flux-value]');
  const tiles = [...root.querySelectorAll('.flux-colors__item')];
  const own = root.querySelector('.flux-colors__item.is-current') || tiles[0];
  const ownText = value ? value.textContent : '';
  const tryOn = window.matchMedia('(hover: hover) and (min-width: 778px)');

  const place = (tile) => {
    if (!mark || !tile) return;
    const pad = parseFloat(getComputedStyle(mark).getPropertyValue('--pad')) || 7;
    mark.style.transform = `translate(${tile.offsetLeft - pad}px, ${tile.offsetTop - pad}px)`;
    mark.style.width = `${tile.offsetWidth + pad * 2}px`;
    mark.style.height = `${tile.offsetHeight + pad * 2}px`;
  };

  // try-on: a second photo inside the first slide's <picture>, so it gets the same frame as the photo it covers
  let slide = null, peek = null, tag = null;
  const setUp = () => {
    if (peek) return true;
    const gallery = document.querySelector('.product-page media-gallery:not([id$="-duplicate"])');
    slide = gallery && gallery.querySelector('.slider__slide');
    const picture = slide && slide.querySelector('picture');
    const main = picture && picture.querySelector('img');
    if (!main) return false;
    peek = document.createElement('img');
    peek.className = 'flux-peek';
    peek.alt = '';
    peek.sizes = main.sizes;
    picture.append(peek);
    tag = document.createElement('span');
    tag.className = 'flux-peek-tag';
    tag.setAttribute('aria-hidden', 'true');
    slide.append(tag);
    slide.classList.add('has-peek');
    tiles.forEach((t) => {
      if (t === own || !t.dataset.srcset) return;
      const img = new Image();
      img.sizes = main.sizes;
      img.srcset = t.dataset.srcset;
    });
    return true;
  };

  const focus = (tile) => {
    tiles.forEach((t) => t.classList.toggle('is-target', t === tile));
    place(tile);
    if (value) value.textContent = tile === own ? ownText : tile.dataset.label + (tile.hasAttribute('data-pre') ? ` — ${root.dataset.pre}` : '');
    const show = tile !== own && !!tile.dataset.srcset && tryOn.matches && setUp();
    if (show) {
      peek.srcset = tile.dataset.srcset;
      tag.textContent = tile.dataset.label;
    }
    if (slide) slide.classList.toggle('is-peek', show);
  };

  list.addEventListener('pointerover', (e) => {
    const tile = e.target.closest('.flux-colors__item');
    if (tile && e.pointerType !== 'touch') focus(tile);
  });
  list.addEventListener('pointerleave', () => focus(own));
  list.addEventListener('focusin', (e) => {
    const tile = e.target.closest('.flux-colors__item');
    if (tile) focus(tile);
  });
  list.addEventListener('focusout', (e) => {
    if (!list.contains(e.relatedTarget)) focus(own);
  });

  // first placement without the flight (the CSS already put the corners on the first row), then animate
  const settle = () => place(root.querySelector('.flux-colors__item.is-target') || own);
  settle();
  requestAnimationFrame(() => requestAnimationFrame(() => mark && mark.classList.remove('is-instant')));
  window.addEventListener('resize', settle);
  window.addEventListener('load', settle);
})();
